<template>
  <div id="theme-select">

    <memlist-modal ref="theme-select-modal" size="xxl">
      <m-row>
        <m-col lg="12">
          <p class="text-center">Välj mall att utgå ifrån</p>
        </m-col>
      </m-row>
      <m-row>
        <m-col
          v-for="tpl in themes"
          :key="tpl.template_id"
          lg="3"
          class="d-flex"
        >
          <!-- full-width card that reacts on hover/click -->
          <memlist-card
            class="template-card w-100 mt-4"
            @click="selectTemplateClicked(tpl)"
          >
            <!-- circular ID badge -->
            <span class="template-badge">{{ tpl.template_id }}</span>

            <!-- centred preview -->
            <img
              v-if="tpl.is_email"
              class="template-img"
              :src="`${image_url}/template-preview/${tpl.template_id}`"
              :alt="tpl.name"
            />
            <span
              v-else-if="tpl.is_sms"
              class="template-icon"
            >
              <inline-svg src="/assets/svg/sms.svg"></inline-svg>
            </span>

            <!-- title inside the card -->
            <h6 class="template-title text-truncate">
              {{ tpl.name }}
            </h6>
          </memlist-card>
        </m-col>
      </m-row>
    </memlist-modal>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { get_domain_url, get_base_url, downloadWithAxios } from '@/core/services/fileDownload';


export default {
  name: 'TemplateSelectThemeModal',
  components: {
 
  },

  mixins: [ toasts ],
  
  computed: {
    ...mapGetters(['currentCompanyId', 'currentPeriodId']),

    image_url() {
      const domain = get_domain_url();

      if (domain.indexOf('localhost') >= 0) {
        return `http://localhost:3020`;
      }

      return '';
    },
  },
  emits: ['selected'],
  async mounted() {
  
  },
  methods: {
    selectTemplateClicked(template) {
      this.$emit('selected', template);
      this.hide();
    },
    
    hide() {
      
      this.$nextTick(()=>{
        this.$refs['theme-select-modal'].hide();  
      });
    },
    
    
    show() {
      
      this.load_themes();

      this.$nextTick(()=>{
        this.$refs['theme-select-modal'].show();
      });
    },

    async load_themes() {

      const loader = this.$loading.show();

      try {
        this.themes = [];
        const res = await axios.get(`/template?show_theme=true`);
    
        if (res.status === 200) {
          this.themes = res.data.filter(i => i.is_theme && i.is_email);
        }
      }
      catch (err) {
        console.error(err);
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('TEMPLATE.UNABLE_LIST'));
      }

      loader.hide();
    },
  },
  data() {
    return {
      themes: []
    };
  },
  
};
</script>
<style lang="scss" scoped>
.template-card {
  position: relative;
  padding: 0.75rem;
  transition: box-shadow 0.15s, transform 0.15s;
  cursor: pointer;
}

.template-card:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

/* -------- circular ID badge -------- */
.template-badge {
  position: absolute;
  top: 0.5rem;
  left: 0.5rem;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  color: #3699ff;
  border: 1px solid #3699ff;
  font-size: 0.8rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

/* -------- centred image -------- */
.template-img {
  display: block;
  width: 100%;
  height: 500px;
  object-fit: cover;
  object-position: top;
}

.template-icon {
  display: block;        /* makes margin auto work */
  max-width: 100px;      /* same visual size as before */
  max-height: 200px;
  margin: 0 auto;        /* centres horizontally */
  text-align: center;    /* centres inline-svg’s internal paths */
}


/* -------- title -------- */
.template-title {
  margin-top: 0.75rem;
  margin-bottom: 0;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* remove old helper */
.image-preview { display: none; }

</style>
